import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'

export const Route = createFileRoute('/_app/suppliers')({
  staticData: { crumb: 'suppliers' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'suppliers.read'),
  component: Outlet,
})
